import { getEmailHash } from '~/utils'
import type {
  TrackingEvent,
  TrackingPayload,
  TrackCustomerDataParams,
} from '~/types/tracking'
import { useMurId } from '~/composables/useMurId'

const useCustomerEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => void,
) => ({
  trackCustomerData: async (params: TrackCustomerDataParams) => {
    const { murId } = useMurId({ user: params?.user })
    const birthDate = params?.user?.birthDate
    const ageByDate =
      birthDate && new Date().getFullYear() - new Date(birthDate).getFullYear()

    track('customer_data', {
      customer_id: params.isLoggedIn ? params.user?.id : undefined,
      gender: params.user?.gender || '',
      logged_in: params?.user?.authentication?.type,
      age: ageByDate,
      eh: params?.isLoggedIn
        ? await getEmailHash(params.user?.email || '')
        : '',
      login_status: params?.isLoggedIn,
      mur_id: murId.value || '',
    })
  },
})

export default useCustomerEvents
